import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OnlyNumberDirective } from '@zlib/directives';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MomentModule } from 'ngx-moment';
import { SearchBarComponent } from './components';
import { NzUploadCropperComponent } from './nz-upload-cropper/nz-upload-cropper.component';
import { EDateSecondTimePipe } from './pipes/date-second.pipe';
import { SafePipe } from './pipes/safe.pipe';

const NZ_MODULES = [
    NzSpinModule,
    NzGridModule,
    NzSliderModule,
    NzModalModule,
    NzIconModule,
    NzMenuModule,
    NzSelectModule,
    NzLayoutModule,
    NzInputModule,
    NzAvatarModule,
];

@NgModule({
    declarations: [
 
    ],
    imports: [
        OnlyNumberDirective,
        SafePipe,

        SearchBarComponent,
        NzUploadCropperComponent,
        EDateSecondTimePipe,
        MomentModule,
        TranslateModule.forChild(),
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NzUploadModule,
        ImageCropperModule,
        ...NZ_MODULES
    ],
    exports: [
    ]
})
export class SharedModule { }
